var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 105,
    viewBox: "0 0 140 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7608 104.466C99.387 104.466 121.782 82.0502 121.782 54.3993C121.782 26.7485 99.387 4.33301 71.7608 4.33301C44.1347 4.33301 21.7393 26.7485 21.7393 54.3993C21.7393 82.0502 44.1347 104.466 71.7608 104.466Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.06 65.7693C133.172 65.7693 134.885 64.0554 134.885 61.9413C134.885 59.8271 133.172 58.1133 131.06 58.1133C128.948 58.1133 127.235 59.8271 127.235 61.9413C127.235 64.0554 128.948 65.7693 131.06 65.7693Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1685 19.9841C27.5582 19.9841 28.6847 18.8566 28.6847 17.4657C28.6847 16.0748 27.5582 14.9473 26.1685 14.9473C24.7789 14.9473 23.6523 16.0748 23.6523 17.4657C23.6523 18.8566 24.7789 19.9841 26.1685 19.9841Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 66.9068C0 70.1304 2.61682 72.7495 5.83753 72.7495H57.5701C58.0733 72.7495 58.5766 72.951 58.8785 73.2532L66.1251 80.5063C66.3264 80.8085 66.729 80.9093 67.1316 80.7078C67.4335 80.607 67.7355 80.2041 67.7355 79.9019V46.3564C67.7355 43.1328 65.1186 40.5137 61.8979 40.5137H5.83753C2.61682 40.5137 0 43.1328 0 46.3564V66.9068Z",
    fill: "#CED6E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16.3931C43 19.6167 45.6168 22.2359 48.8375 22.2359H57.5701C58.0733 22.2359 58.5766 22.4374 58.8785 22.7396L66.1251 29.9926C66.3264 30.2948 66.729 30.3956 67.1316 30.1941C67.4335 30.0934 67.7355 29.6904 67.7355 29.3882V5.84275C67.7355 2.61916 65.1186 0 61.8979 0H48.8375C45.6168 0 43 2.61916 43 5.84275V16.3931Z",
    fill: "#CED6E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.738 10H48.262C48.131 10 48 9.61905 48 9.2381V6.7619C48 6.38095 48.131 6 48.262 6H62.738C62.869 6 63 6.38095 63 6.7619V9.2381C63 9.71429 62.9017 10 62.738 10Z",
    fill: "url(#paint0_linear_169_10555)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.738 16H48.262C48.131 16 48 15.619 48 15.2381V12.7619C48 12.381 48.131 12 48.262 12H62.738C62.869 12 63 12.381 63 12.7619V15.2381C63 15.7143 62.9017 16 62.738 16Z",
    fill: "url(#paint1_linear_169_10555)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.0539 53.6089H10.5679C10.1653 53.6089 9.7627 53.2059 9.7627 52.803V50.1838C9.7627 49.7809 10.1653 49.3779 10.5679 49.3779H55.0539C55.4565 49.3779 55.859 49.7809 55.859 50.1838V52.803C55.859 53.3067 55.5571 53.6089 55.0539 53.6089Z",
    fill: "url(#paint2_linear_169_10555)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.9439 64.5894H10.5679C10.1653 64.5894 9.7627 64.1864 9.7627 63.7835V61.1643C9.7627 60.7613 10.1653 60.3584 10.5679 60.3584H37.9439C38.3465 60.3584 38.749 60.7613 38.749 61.1643V63.7835C38.749 64.2871 38.4471 64.5894 37.9439 64.5894Z",
    fill: "url(#paint3_linear_169_10555)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140 27.3168C140 30.2382 137.685 32.5551 134.766 32.5551H88.2673C87.8647 32.5551 87.3615 32.7566 87.0595 33.0588L80.5175 39.6067C80.3162 39.8082 79.9136 39.9089 79.6116 39.8082C79.3097 39.7074 79.1084 39.4052 79.1084 39.103V8.88189C79.1084 5.96051 81.4233 3.64355 84.342 3.64355H134.666C137.584 3.64355 139.899 5.96051 139.899 8.88189V27.3168H140Z",
    fill: "#CED6E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M129.633 15.4296H89.6762C89.2736 15.4296 88.9717 15.1274 88.9717 14.7244V12.3067C88.9717 11.9038 89.2736 11.6016 89.6762 11.6016H129.633C130.036 11.6016 130.338 11.9038 130.338 12.3067V14.7244C130.338 15.1274 130.036 15.4296 129.633 15.4296Z",
    fill: "url(#paint4_linear_169_10555)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M114.335 25.3016H89.6762C89.2736 25.3016 88.9717 24.9994 88.9717 24.5965V22.1788C88.9717 21.7758 89.2736 21.4736 89.6762 21.4736H114.335C114.737 21.4736 115.039 21.7758 115.039 22.1788V24.5965C115.039 24.8987 114.637 25.3016 114.335 25.3016Z",
    fill: "url(#paint5_linear_169_10555)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.892 92.2304C129.892 94.4802 128.109 96.2644 125.861 96.2644H90.0531C89.7431 96.2644 89.3556 96.4196 89.1231 96.6523L84.0851 101.695C83.9301 101.85 83.6201 101.927 83.3875 101.85C83.155 101.772 83 101.54 83 101.307V78.034C83 75.7843 84.7827 74 87.0304 74H125.784C128.032 74 129.814 75.7843 129.814 78.034V92.2304H129.892Z",
    fill: "#CED6E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.909 83.0768H91.1382C90.8282 83.0768 90.5957 82.8441 90.5957 82.5338V80.6719C90.5957 80.3616 90.8282 80.1289 91.1382 80.1289H121.909C122.219 80.1289 122.451 80.3616 122.451 80.6719V82.5338C122.451 82.8441 122.219 83.0768 121.909 83.0768Z",
    fill: "url(#paint6_linear_169_10555)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M110.127 90.6793H91.1382C90.8282 90.6793 90.5957 90.4466 90.5957 90.1363V88.2745C90.5957 87.9642 90.8282 87.7314 91.1382 87.7314H110.127C110.437 87.7314 110.67 87.9642 110.67 88.2745V90.1363C110.67 90.369 110.36 90.6793 110.127 90.6793Z",
    fill: "url(#paint7_linear_169_10555)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_10555",
    x1: 63.401,
    y1: 7.98853,
    x2: 48.1058,
    y2: 7.98853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_10555",
    x1: 63.401,
    y1: 13.9885,
    x2: 48.1058,
    y2: 13.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_10555",
    x1: 57.0913,
    y1: 51.4813,
    x2: 10.0877,
    y2: 51.4813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_169_10555",
    x1: 39.5239,
    y1: 62.4617,
    x2: 9.96708,
    y2: 62.4617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_169_10555",
    x1: 131.443,
    y1: 13.5046,
    x2: 89.2634,
    y2: 13.5046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_169_10555",
    x1: 115.736,
    y1: 23.3767,
    x2: 89.1555,
    y2: 23.3767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_169_10555",
    x1: 123.303,
    y1: 81.5944,
    x2: 90.8203,
    y2: 81.5944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_169_10555",
    x1: 111.207,
    y1: 89.1969,
    x2: 90.7372,
    y2: 89.1969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00651336,
    stopColor: "#A6AEBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AAB5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.c1d30d8ce4f33d5e364ea723cf97cccb.svg";
export { ForwardRef as ReactComponent };